import React, { useEffect, useState } from "react";
import "./EcommerceSinglePage.scss"
import { useHistory, useParams } from 'react-router';
import plus from "../../assets/plus.svg"
import minus from "../../assets/minus.svg"
import Button from "../../components/Button/Button";
import visa from "../../assets/images/pay_visa.png"
import amex from "../../assets/images/pay_amex.png"
import master from "../../assets/images/pay_master.png"
import Accordion from "../../components/Accordion/Accordion";
import placeholder from "../../assets/collections/empty.jpg"
import NotifyModal from "./NotifyModal/NotifyModal";
import Modal from "../../components/Modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import { setCart, setWishlist } from "../../../../../../../redux/companyDataSlice";
import { addItemToWishList, getWishlist } from "../../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../../../utilities/helper";
const EcommerceSinglePage = () => {
    const params = useParams();
    const dispatch = useDispatch()
    const history = useHistory()

    const [item, setItem] = useState(
        localStorage.getItem("ECOM_ITEM") ? JSON.parse(localStorage.getItem("ECOM_ITEM")) :
            null)
    const [isVisible, setIsVisible] = useState(false)
    const [isSuccessVisible, setIsSuccessVisible] = useState(false)
    const [isFailedVisible, setIsFailedVisible] = useState(false)
    const cart = useSelector((state) => state.companyData.cart)
    const wishlist = useSelector((state) => state.companyData.wishlist)
    const companyData = useSelector((state) => state.companyData.company)
    const [isShowLoginModal, setIsShowLoginModal] = useState(false);
    const [cartItem, setcartItem] = useState(null)

    const categoryProducts = useSelector((state) => state.companyData.categoryProducts)
    const items = [
        { title: "Details", content: "This Floral Pattern Colorful Summer Tee is a must-have for any summer wardrobe. The colorful floral pattern adds a touch of fun to any outfit, while the lightweight fabric keeps you cool and comfortable on hot days. Expertly crafted with high-quality materials, this tee is both stylish and durable. Experience the perfect blend of fashion and function with this versatile piece." },
    ];
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        if (cart) {
            let cartI = cart?.find((cartItem) => cartItem.ProductID === item?.ProductID) ?? null
            setcartItem(cartI)
            let updatedProduct = item;
            if (cartI) {
                updatedProduct = { ...item, Quantity: cartI.ProductQty };

            } else {
                updatedProduct = { ...item, Quantity: 1 };
            }
            setItem(updatedProduct);
            localStorage.setItem("ECOM_ITEM", JSON.stringify(updatedProduct));
        }
    }, [cart])
    useEffect(() => {
        if (params.id) {
            let product = categoryProducts?.Result?.filter((value) => value.ID === params.id)[0]
            if (product) {
                let cartI = cart.find((cartItem) => cartItem.ProductID === product.ProductID) ?? null
                setcartItem(cartI)
                const updatedProduct = { ...product, Quantity: cartI ? cartI.ProductQty : 1 };
                setItem(updatedProduct);
                localStorage.setItem("ECOM_ITEM", JSON.stringify(updatedProduct));
            }
        }
    }, [params.id])
    const increaseQty = () => {
        if (item) {
            let newItem = { ...item, Quantity: item?.Quantity ? item?.Quantity + 1 : 1 }
            setItem(newItem)
            localStorage.setItem("ECOM_ITEM", JSON.stringify(newItem))
        }
    }
    const decreaseQty = () => {
        if (item?.Quantity > 1) {
            let newItem = { ...item, Quantity: item?.Quantity ? item?.Quantity - 1 : 0 }
            setItem(newItem)
            localStorage.setItem("ECOM_ITEM", JSON.stringify(newItem))
        }
    }
    const addToCart = () => {
        const product = {
            ProductID: item?.ProductID,
            ProductName: item?.Name,
            ProductQty: item?.Quantity,
            ProductPrice: item?.SellingPricesArray.SellingPrice,
            ProductImage: item?.OnLineImages?.PrimaryImages?.Main,
            OfferAmount: 0,
            VatRate: JSON.parse(localStorage.getItem("ECOM_CAT")) ? JSON.parse(localStorage.getItem("ECOM_CAT")).find(
                (category) =>
                    category.ProductCategory.ProductCategoryID === item?.ProductCategoryID
            ).ProductCategory.VatRate : 0,
            productdetails: item
        }
        if (cart.length > 0) {
            let isAvailable = cart.find((cartItem) => cartItem.ProductID === product.ProductID)
            if (isAvailable) {
                let updated = cart.map(item =>
                    item?.ProductID === product.ProductID
                        ? { ...item, ProductQty: product.ProductQty }
                        : item
                )
                dispatch(setCart(updated))

            } else {
                dispatch(setCart([...cart, product]))
            }

        } else {
            dispatch(setCart([product]))
        }

    }
    const addToWishList = async () => {
        let data = {
            "ProductName": item?.Name,
            "ProductID": item?.ID,
            "StoreID": companyData?.LocationID,
            "IsLikedByCustomer": wishlist.length > 0 ? wishlist?.find((wish) => wish.ProductID === item?.ID) ? false : true : true
        }
        if (data.IsLikedByCustomer) {
            dispatch(setWishlist([...wishlist, data]))
        } else {
            let updatedList = wishlist.filter((wish) => wish.ProductID !== item?.ID)
            dispatch(setWishlist(updatedList))
        }
        const userId = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
        await addItemToWishList(data, userId).then(async (response) => {
            if (response) {
                console.log("SUCCESS")
            }
        })

    }
    return (

        <div className="EcommerceSinglePage">
            <div className="EcommerceSinglePage-left">
                <img alt="" src={item?.OnLineImages?.PrimaryImages?.Main ?? placeholder} />
            </div>
            <div className="EcommerceSinglePage-right">
                <div className="item-header">{item?.Name}</div>
                <div className="item-ref" >PRODUCT REF NO: {item?.ProductRefNo}</div>
                <div className="item-price"><div className="mrp">M.R.P
                </div> £{(item?.SellingPricesArray?.SellingPrice)?.toFixed(2)}</div>
                <div className="item-vendor"><b>Vendor:</b>Casipillai Designer Collection</div>
                {!item?.IsOutOfStock ?
                    <>
                        <div className="item-container">
                            <div className="qty-container">
                                <div className={`qty-cont-action  ${item?.Quantity === 1 ? "disable" : ""}`} onClick={decreaseQty}><img alt="" src={minus} /></div>
                                <div className="qty-cont-item">{item?.Quantity}</div>
                                <div className="qty-cont-action " onClick={increaseQty}><img alt="" src={plus} /></div>
                            </div>
                            <div className="btn-container">
                                <div className="btn-item">
                                    <Button text={wishlist?.find((wish) => wish.ProductID === item?.ID) ? "Wishlisted" : "Add To Wishlist"} invert width={window.screen.width < 900 ? "100%" : ""}
                                        onClick={() => {
                                            addToWishList()
                                        }}
                                    />
                                </div>
                                <div className="btn-item">
                                    <Button text={cartItem ? "Update Cart" : "Add To Cart"} width={window.screen.width < 900 ? "100%" : ""}
                                        onClick={addToCart} />
                                </div>
                            </div>


                        </div>
                        <div className="buy-btn">
                            <Button text={"Buy It Now"} width={"100%"}
                                onClick={() => {
                                    if (localStorage.getItem('isLogged') === 'true') {
                                        addToCart()
                                        history.push("/pages/checkout")
                                    } else {
                                        setIsShowLoginModal(true)
                                    }
                                }} />

                        </div>
                    </> : <div className="buy-btn">
                        <Button text={"Notify"} width={"100%"} onClick={() => {
                            setIsVisible(true)
                        }} />

                    </div>}

                <div className="payment-container">
                    <div className="payment-text" >Granteed safe checkout</div>
                    <div className="payment-cards ">
                        <img alt="" src={visa} />
                        <img alt="" src={amex} />
                        <img alt="" src={master} />
                    </div>
                </div>
                <div className="details-container">
                    <Accordion items={items} icon isOpen layout={"layout2"} />
                </div>


            </div>
            {isVisible && <NotifyModal setIsVisible={setIsVisible} product={item?.Name} setIsFailedVisible={setIsFailedVisible} setIsSuccessVisible={setIsSuccessVisible} />}
            {isSuccessVisible && <Modal
                header={"Notification Request Received"}
                subText={`We’ve successfully received your email. You’ll be notified as soon as the product is available again.`}
                isSuccess
                onClick={() => {
                    setIsSuccessVisible(false)
                }} />}
            {isFailedVisible && <Modal
                header={"Oops! Something Went Wrong"}
                subText={`We couldn’t send your email at the moment. Please try again later.`}
                isFailed
                onClick={() => {
                    setIsFailedVisible(false)
                }} />}
            {isShowLoginModal && <Modal isAlert header={"Login Required"} subText={"To continue with your checkout, please log in to your account."} buttonText="Log In Now"
                onClick={() => {
                    setIsShowLoginModal(false)
                    history.push("/account/login")

                }} />}
        </div>
    )

}
export default EcommerceSinglePage